import styled from "styled-components/native";
import FastImage from "react-native-fast-image-web-support";

export default styled(FastImage).attrs({ resizeMode: "contain" })`
  height: 100px;
  width: 100%;
  border-radius: 2px;
`;
